export default "__VITE_ASSET__BGkjM$JT__"